import { useAddToFollowerMutation, useRemoveFromFollowerMutation } from './gql/graphql.v3.generated';

interface Payload {
  userId: number,
  onSuccess?: () => void,
  onError?: () => void,
}

export const useUserSubscription = () => {
  const [addToFollower, {
    loading: addToFollowerLoading,
  }] = useAddToFollowerMutation();
  const [removeFromFollower, {
    loading: removeFromFollowerLoading,
  }] = useRemoveFromFollowerMutation();

  const handleSubscribe = ({
    userId,
    onSuccess,
    onError,
  }: Payload) => {
    addToFollower({
      variables: {
        userId,
      },
    }).then(({ data }) => {
      if (data?.addToFollower?.isSuccess && onSuccess) {
        onSuccess();
      } else if (!data?.addToFollower?.isSuccess && onError) {
        onError();
      }
    }).catch(() => {
      if (onError) {
        onError();
      }
    });
  };

  const handleUnsubscribe = ({
    userId,
    onSuccess,
    onError,
  }: Payload) => {
    removeFromFollower({
      variables: {
        userId,
      },
    }).then(({ data }) => {
      if (data?.removeFromFollower?.isSuccess && onSuccess) {
        onSuccess();
      } else if (!data?.removeFromFollower?.isSuccess && onError) {
        onError();
      }
    }).catch(() => {
      if (onError) {
        onError();
      }
    });
  };

  return {
    loading: addToFollowerLoading || removeFromFollowerLoading,
    handleSubscribe,
    handleUnsubscribe,
  };
};
